import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/conditions/page.tsx");
